import { RevamppDataAsset } from "../../../../shared/entities/data-asset/revampp-data-asset";
import { DataAssetTable } from "./data-sharing-assets.table";

export class DataSharingAssetsPage {
    assetTable: DataAssetTable;

    constructor() {
        this.assetTable = new DataAssetTable();

        $(() => {
            this.assetTable.initialize();
        });


        // resize tables on navbar collapse/show
        $(".nav-column").on("shown.bs.collapse hidden.bs.collapse", () => {
            // delay to let collapse animations complete
            setTimeout(() => {
                if (this.assetTable) {
                    this.assetTable.resizeTable();
                }
            }, 250)
        })
    }
}